import { render, staticRenderFns } from "./UpdateTime.vue?vue&type=template&id=15a9e9d0"
import script from "./UpdateTime.vue?vue&type=script&lang=js"
export * from "./UpdateTime.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports